
import { WorkplaceShutdownModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Ref } from 'vue-property-decorator';
import { Guid } from '@/libs/common/functions/guid';
import { workplaceShutdownsStore } from '@/libs/workplaces/+state/store';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import Loader from '@/libs/common/components/Loader.vue';
import ConfirmDialog from '@/libs/common/components/ConfirmDialog.vue';
import WorkplaceSelect from '@/libs/common/components-smart/WorkplaceSelect.vue';
import DateTimePicker from '@/libs/common/components/DateTimePicker.vue';

@Component({
    components: { Loader, ConfirmDialog, WorkplaceSelect, DateTimePicker },
})
export default class WorkplaceShutdownDialog extends Page {
    id!: string;
    dialog = false;
    valid = true;
    saving = false;
    loading = false;
    shutdown: WorkplaceShutdownModel | null = null;
    deleteDialog = false;
    deleting = false;
    fromMenu = false;
    toMenu = false;

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.shutdown?.id == Guid.EmptyGuid();
    }

    open(id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close() {
        this.dialog = false;
    }

    deleteClick() {
        this.deleteDialog = true;
    }

    deleteShutdown() {
        this.deleting = true;
        workplaceShutdownsStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(workplaceShutdownsStore, CrudReponse.Delete)
            .then(() => {
                this.deleting = false;
                this.deleteDialog = false;
                this.close();
            })
            .catch(() => {
                this.deleting = false;
            });
    }

    private load(): Promise<any> {
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                workplaceShutdownsStore.dispatch(CrudAction.Get, { id: this.id });
                this.subscribe(workplaceShutdownsStore, CrudReponse.Get)
                    .then((item: WorkplaceShutdownModel) => {
                        this.shutdown = item;
                        this.loading = false;
                        resolve(item);
                    })
                    .catch((e: any) => {
                        this.loading = false;
                        reject(e);
                    });
            });
        } else {
            this.shutdown = {
                id: Guid.EmptyGuid(),
                workplaceId: undefined,
                fromDate: undefined,
                toDate: undefined,
            } as WorkplaceShutdownModel;
            return Promise.resolve(null);
        }
    }

    save() {
        if (!this.valid || !this.shutdown) return;
        this.saving = true;
        const action = this.isNewItem ? CrudAction.Create : CrudAction.Update;
        workplaceShutdownsStore.dispatch(action, { item: this.shutdown });
        this.subscribe(workplaceShutdownsStore, this.isNewItem ? CrudReponse.Create : CrudReponse.Update)
            .then(() => {
                this.saving = false;
                this.close();
            })
            .catch(() => {
                this.saving = false;
            });
    }
}
